import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import { roleActivityListApi } from "../../../api/Api";
import ContentData from "../../../constants/contentFile.json";
import { useCookies } from "react-cookie";

export const RoleActivityContext = createContext({});
export const RoleActivityContextProvider = ({ children }) => {
  const [roleActivityList, setRoleActivityList] = useState([]);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();

  const roleActivityListShow = async (page) => {
    try {
      setSpinnerStatus(true);
      const getActivityList = await roleActivityListApi(page);
      const logs = getActivityList?.data?.data?.logs;

      if (getActivityList?.status === 200) {
        if (logs.length > 0) {
          setSpinnerStatus(false);
          setRoleActivityList((prevLogs) => [...prevLogs, ...logs]);
          setCurrentPage(page);
        } else {
          setHasMore(false); // No more logs to load
        }
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;

      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText(ContentData.tenantPage.login);
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }
    }
    setSpinnerStatus(false);
  };

  const roleToLogin = () => {
    removeCookie("x-access-token");
    navigate(RouteConstants.LOGIN);
  };

  const activityPageToList = () => {
    navigate(RouteConstants.ROLE_LIST);
  };

  // close error modal
  const onHandleClose = () => {
    setErrorPopup(false);
  };

  useEffect(() => {
    roleActivityListShow(currentPage);
  }, []);

  const providerValue = {
    roleActivityListShow,
    roleActivityList,

    roleToLogin,
    statusValue,
    buttonText,

    spinnerStatus,
    activityPageToList,
    currentPage,
    hasMore,
    errorPopup,
    errorPopupMessage,
    buttonText,
    statusValue,
    setErrorPopup,
  };
  return (
    <RoleActivityContext.Provider value={providerValue}>
      {children}
    </RoleActivityContext.Provider>
  );
};
